'use strict';
(function($){
	/*
	 * Vetology.Filters widget
	 *
	 * @description This is the main Vetology Filters widget to add filtering capabilities to input fields and select boxes
	 *
	 * @options					See description for each option
	 *
	 * @method	See description above each method
	 */
	$.widget(
		'Vetology.Filters',
		{
			"options": {
			},
			/*
			 * Vetology.Vetology._init
			 *
			 * @description	Initializes the Filters
			 *
			 * @return NULL
			 *
			 */
			"_init": function(){
				var o = this;
				var search = location.search.replace("?", "").split("&");
				var filters = {};
				$.each(search, function(i, f){
					f = f.split("=");
					if(f.length === 2 && f[1] !== ""){
						filters[f[0]] = f[1]
					}
				});
				o.setFilters(filters);
				o._activateRelatedPopups();
				o._addEventListeners();
			},
			/*
			 * Vetology.Vetology.setFilters
			 *
			 * @description	Adds listeners to all fileds that should work as filters
			 *
			 * @return NULL
			 *
			 */
			"setFilters": function(filters){
				$.each(filters, function(i, f){
					var el = $('.isFilter[data-filter="' + i + '"]');
					if(el.length > 0){
						el.val(f);
					}
				});
			},
			/*
			 * Vetology.Vetology._addEventListeners
			 *
			 * @description	Adds listeners to all fileds that should work as filters
			 *
			 * @return NULL
			 *
			 */
			"_addEventListeners": function(){
				var o = this;
				$("body").on("click", ".pagerTarget a, .pagerTarget2 a", function(e){
					e.preventDefault();
					var el = $(this);
					var page = parseInt(el.attr("href").replace("?page=", "")) > 0 ? parseInt(el.attr("href").replace("?page=", "")) : 1;
					$('input.isFilter[data-filter="page"]').val(page);
					o.getRecords(true);
				});
				$("body").on("click", "a[data-sort]", function(e){
					e.preventDefault();
					var el = $(this);
					var active = el.data("active");
					$("a[data-sort]").data("active", false).attr('class', 'vetology-sort-asc');
					el.data('active', true);
					$('input.isFilter[data-filter="sort"]').val(el.data('sort'));
					$('input.isFilter[data-filter="sortDirection"]').val(el.data('direction'));
					if(el.data('direction') == 'asc'){
						el.data('direction', 'desc');
						el.attr('class', 'vetology-sort-desc');
					} else {
						el.data('direction', 'asc');
						el.attr('class', 'vetology-sort-asc');
					}
					clearTimeout(window.ajax);
					o.getRecords(true);
				});
				$("body").on('input change', '.isFilter', function(e){
					if(e.type == 'change' && $(this).is('input')){
						return;
					}
					if($(this).data('filter') == 'perpage'){
						$('input[data-filter="page"]').val(1);
					}
					const event = new CustomEvent('filter-change', { detail: {
							filter: $(this).data('filter'),
							value: $(this).val(),
							originalEvent: e
						}
					});
					document.dispatchEvent(event);

					$('input[data-filter="page"]').val(1);
					if($(this).is('input')){
						clearTimeout(window.ajax);
						window.ajax = setTimeout(
							function(){
								o.getRecords(true);
							},
							2500
						);
					} else {
						o.getRecords(true);
					}
				});

				$('.dateRange').on('apply.daterangepicker', function(ev, picker) {
					$(this).val(picker.startDate.format('YYYY-MM-DD') + ' / ' + picker.endDate.format('YYYY-MM-DD'));
					clearTimeout(window.ajax);
					window.ajax = setTimeout(
						function(){
							o.getRecords(true);
						},
						2500
					);
				});

				$('.dateRange').on('cancel.daterangepicker', function(ev, picker) {
					$(this).val('');
					clearTimeout(window.ajax);
					window.ajax = setTimeout(
						function(){
							o.getRecords(true);
						},
						2500
					);
				});
			},
			/*
			 * Vetology.Vetology.getRecords
			 *
			 * @description	Triggers the search for records based on the given filters
			 *
			 * @return NULL
			 *
			 */
			"getRecords": function(force){
				var o = this;
				if(o.options.timeout){
					clearTimeout(o.options.timeout);
					o.options.timeout = null;
				}
				o.options.timeout = setTimeout(
					function(){
						clearTimeout(o.options.timeout);
						var data = {};
						var filters = $('input.isFilter, select.isFilter, textarea.isFilter, input.dateRange');
						$.each(filters, function(i, el){
							el = $(el);
							if(typeof el.data('filter') != "undefined" && typeof el.val() != "undefined"){
								data[el.data('filter')] = el.val();
							}
						});
                        $("body").addClass("filteringRecords");
						$("body").Vetology(
							"doRequest",
							"POST",
							data,
							window.location.href,
							function(json){
								$("body").removeClass("filteringRecords");
								$(".targetHtml").html(json.data);
								$(".pagerTarget").html(json.pager);
								$(".pagerTarget2").html(json.pager2);
								if(typeof json.window != "undefined"){
									window.vet_data = json.window;
								} else {
									window.vet_data = null;
								}
								o._activateRelatedPopups();
							},
							"JSON"
						);
					}
				);
			},
            _activateRelatedPopups: function() {
                $('.related-cases-popover').popover({
                    trigger: 'manual',
                    html: true,
                    animation: false
                })
                .on('mouseenter', function () {
                    var _this = this;
                    $(this).popover('show');
                    $('.popover').on('mouseleave', function () {
                        $(_this).popover('hide');
                    });
                }).on('mouseleave', function () {
                    var _this = this;
                    setTimeout(function () {
                        if (!$('.popover:hover').length) {
                            $(_this).popover('hide');
                        }
                    }, 100);
                })

            }
		}
	);
})(jQuery);